import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";
import { useMutation, useQuery } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { toDate } from "date-fns";

const login = async (input) => {
  if (!input) {
    throw new Error("Input is required for login mutation");
  }

  try {
    const { data } = await http_payroll.post(
      Api_EndPoints.UserValidation,
      input,
    );
    if (!data) {
      throw new Error("No data returned from login API");
    }
    return data;
  } catch (error) {
    console.error("Login mutation error:", error);
    throw error;
  }
};

const loginHistory = async (input) => {
  if (!input) {
    throw new Error("Input is required for login mutation");
  }

  try {
    const { data } = await http_payroll.post(Api_EndPoints.LoginHistory, input);
    if (!data) {
      throw new Error("No data returned from login API");
    }
    return data;
  } catch (error) {
    console.error("Login mutation error:", error);
    throw error;
  }
};

const logout = async (input) => {
  if (!input) {
    throw new Error("Input is required for login mutation");
  }

  try {
    const { data } = await http_payroll.put(Api_EndPoints.Logout, input);
    if (!data) {
      throw new Error("No data returned from login API");
    }
    return data;
  } catch (error) {
    console.error("Login mutation error:", error);
    throw error;
  }
};

const getUserLoginHistory = async ({
  userId,
  companyCode,
  type = "ALL",
  status = 0,
  fromDate,
  toDate,
}) => {
  let queryParams = `?CompanyCode=${companyCode}&UserID=${userId}&FromDate=${fromDate}&ToDate=${toDate}`;

  if (status !== 0) {
    queryParams += `&Status=${status === 1 ? true : status === 2 ? false : false}`;
  }

  if (type !== "ALL") {
    queryParams += `&Type=${type}`;
  }
  const { data } = await http_payroll.get(
    `${Api_EndPoints.GetUserLoginHistory}${queryParams}`,
  );
  return data;
};

export const useLoginMutation = () => {
  return useMutation({
    mutationFn: login,
  });
};

export const useUpdateLoginHistoryMutation = () => {
  return useMutation({
    mutationFn: loginHistory,
  });
};

export const useLogoutMutation = () => {
  return useMutation({
    mutationFn: logout,
  });
};

export const useGetUserLoginHistory = (input) => {
  console.log("Input for useGetUserLoginHistory:", input);
  return useQuery({
    queryKey: [Api_EndPoints.GetUserLoginHistory],
    queryFn: () => getUserLoginHistory(input),
  });
};
